/*
  Size & fit modal (snippets/size-help-modal.liquid), opened by "Need help with sizing?".
  - Mini converter: UK / US / EU / FR size to the Australian size, from the embedded size map
    (the same generated data as /pages/bra-size-chart). US DD/E and DDD/F answer to either
    letter, and G also to DDDD, as on the full converter.
  - While open: hides the chat and Virtual fitting bubbles; on close, focus goes back to the button.
  Everything is delegated, so modals added later (quick view) work without rebinding.
*/
(() => {
  if (window.__sizeHelp) return;
  window.__sizeHelp = true;

  // A row's labels in a system: US "34DD/E" answers to 34DD and 34E; US G also to DDDD
  const labelsOf = (row, sys) => {
    const v = row[sys];
    if (sys !== 'USA') return [v];
    const dual = v.match(/^(\d+)([A-Z]+)\/([A-Z]+)$/i);
    if (dual) return [dual[1] + dual[2], dual[1] + dual[3]];
    const g = v.match(/^(\d+)G$/i);
    return g ? [v, g[1] + 'DDDD'] : [v];
  };

  const rowsOf = (conv) => {
    if (!conv._rows) {
      try { conv._rows = JSON.parse(conv.querySelector('[data-size-help-map]').textContent).rows; }
      catch (e) { conv._rows = []; }
    }
    return conv._rows;
  };

  const fillSizes = (conv) => {
    const sys = conv.querySelector('[data-size-help-sys]').value;
    const select = conv.querySelector('[data-size-help-size]');
    const frag = document.createDocumentFragment();
    const first = document.createElement('option');
    first.value = '';
    first.textContent = 'Select a size';
    frag.appendChild(first);
    rowsOf(conv).forEach((row, i) => labelsOf(row, sys).forEach((label) => {
      const o = document.createElement('option');
      o.value = i;
      o.textContent = label;
      frag.appendChild(o);
    }));
    select.replaceChildren(frag);
    conv.dataset.filled = sys;
    showResult(conv);
  };

  const showResult = (conv) => {
    const value = conv.querySelector('[data-size-help-size]').value;
    const row = value === '' ? null : rowsOf(conv)[+value];
    const result = conv.querySelector('[data-size-help-result]');
    result.hidden = !row;
    if (row) conv.querySelector('[data-size-help-au]').textContent = row.AUS;
  };

  document.addEventListener('change', (e) => {
    const conv = e.target.closest('[data-size-help-conv]');
    if (!conv) return;
    if (e.target.matches('[data-size-help-sys]')) fillSizes(conv);
    else if (e.target.matches('[data-size-help-size]')) showResult(conv);
  });

  // Open / close: bubbles, focus, and filling the converter on first open
  const watched = new WeakSet();
  const onToggle = (modal) => {
    const open = modal.hasAttribute('open');
    document.documentElement.classList.toggle('size-help-open', open);
    if (open) {
      modal._sizeHelpReturn = window.__sizeHelpTrigger || modal._sizeHelpOpener || null;
      window.__sizeHelpTrigger = null;
      modal.querySelectorAll('[data-size-help-conv]').forEach((conv) => { if (!conv.dataset.filled) fillSizes(conv); });
      setTimeout(() => modal.shadowRoot?.querySelector('[part="close-button"]')?.focus({ preventScroll: true }), 50);
    } else {
      const back = modal._sizeHelpReturn;
      modal._sizeHelpReturn = null;
      // Again after a tick: an enclosing quick view's focus trap can grab focus on close
      const refocus = () => { if (back && back.isConnected) back.focus({ preventScroll: true }); };
      refocus();
      setTimeout(refocus, 150);
    }
  };
  const watch = (modal) => {
    if (watched.has(modal)) return;
    watched.add(modal);
    new MutationObserver(() => {
      const open = modal.hasAttribute('open');
      if (open !== !!modal._sizeHelpOpen) {
        modal._sizeHelpOpen = open;
        onToggle(modal);
      }
    }).observe(modal, { attributes: true, attributeFilter: ['open'] });
  };

  // The theme opens the modal from the button whose aria-controls names it; catch that click first
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[aria-controls^="modal-"]');
    if (!btn) return;
    const modal = document.getElementById(btn.getAttribute('aria-controls'));
    if (!modal || !modal.classList.contains('size-help')) return;
    watch(modal);
    if (!window.__sizeHelpTrigger) modal._sizeHelpOpener = btn;
  }, true);
  document.querySelectorAll('hdt-modal.size-help').forEach(watch);
})();
